<template>

  <v-card v-if="resultado.id">
    <v-toolbar :style="`background-color: ${resultado.empresa.cor}`">
      <v-toolbar-title class="white--text"> {{nomeFantasia}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-flex v-if="resultado.id" lg12 xs12 sm12 md12 xl12>
        <h1 class="headline">{{resultado.nomePaciente}}</h1>
        <h2 v-if="resultado.cpfPaciente" class="subheading">
          CPF: {{resultado.cpfPaciente}}
        </h2>
        <h2 v-if="resultado.dataNascimento" class="subheading">
          Data Nascimento: {{resultado.dataNascimento}}
        </h2>
        <h2 v-if="resultado.dataAssinatura == null">Data Publicação: <strong>{{moment(resultado.dataCadastro).format('DD/MM/YYYY hh:mm') }} </strong><br></h2>
        <h2 v-if="resultado.dataAssinatura">Data Assinatura: <strong>{{moment(resultado.dataAssinatura).format('DD/MM/YYYY hh:mm') }} </strong><br></h2>
      </v-flex>
    </v-card-text>
    <v-card-media ref="resultado.id" v-if="resultado.possuiImagem" :src="buscarImage(resultado)" height="200px">
    </v-card-media>
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">{{resultado.tipoExame}} - {{resultado.modalidade}}</h3>
        <div>
          <span v-if="resultado.medico">Médico Executor: <strong>{{resultado.medico.nome}} </strong> 
          <strong> - CRM{{resultado.medico.crmUf}}  {{resultado.medico.crm}}  </strong> 

          </span>
        </div>
      </div>
    </v-card-title>
    <v-card-text class="white">
      <v-btn class="ml-1 mr-1 " v-if="resultado.medico" dark ripple color="primary" outline round  @click.native="openPdf(resultado)">
        <v-icon class="mr-2">picture_as_pdf</v-icon> Visualizar Laudo
      </v-btn>

      <v-btn class="ml-1 mr-1" v-if="resultado.possuiImagem" dark ripple color="primary" round outline @click.native="openViewer(resultado)" >
        <v-icon class="mr-2">collections</v-icon> Visualizar Imagens
      </v-btn>

      <v-btn class="ml-1 mr-1" v-if="resultado.possuiImagem" dark ripple color="primary" round outline @click.native="dialog = true" >
        <v-icon class="mr-2">share</v-icon> Compartilhar
      </v-btn>
      <v-btn class="ml-1 mr-1" v-if="resultado.possuiImagem && resultado.empresa.impressao" dark ripple color="primary" round outline @click.native="dialogImpressao = true" >
        <v-icon class="mr-2">print</v-icon> Imagens para Impressão
      </v-btn>
    </v-card-text>


    <PdfDialog :resultado="resultado" :link="linkPdf" :display.sync="dialogPdf"> </PdfDialog>
    <ViewerDialog :resultado="resultado" :link="linkViewer" :display.sync="dialogViewer"> </ViewerDialog>


    <v-dialog v-if="resultado.id" v-model="dialog" persistent max-width="500px">      
      <v-card>
        <v-card-title>
          <span class="headline">Compartilhar Resultado</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex lg12 xs12 sm12 md12 xl12>
                <h2 class="subheading">Empresa: <b>{{resultado.empresa.nome}}</b></h2>
                <h2 v-if="resultado.unidade" class="subheading">Unidade: <b>{{resultado.unidade.nome}}</b></h2>
                <h2 class="subheading">Paciente: <b>{{resultado.nomePaciente}}</b></h2>
                <h2 class="subheading">Tipo do Exame: <b>{{resultado.tipoExame}} - {{resultado.modalidade}}</b></h2>
              </v-flex>              
            </v-layout>
            <v-layout wrap>
              <v-flex lg12 xs12 sm12 md12 xl12>         
                <v-form v-model="valid" ref="form" lazy-validation @submit.prevent="compartilharEmail">      
                  <v-text-field :rules="emailRules" name="email" v-model="email" label="Digite o e-mail"></v-text-field>      
                </v-form>
              </v-flex>              
            </v-layout>            
            <v-layout wrap>
              <v-flex lg12 xs12 sm12 md12 xl12>               
                <v-btn color="primary" :disabled="!valid" @click.native="compartilharEmail()">Enviar por Email</v-btn>
                <v-btn v-if="detectmob()"  data-action="share/whatsapp/share" color="green" dark @click.native="compartilharWhatsapp()">WhatsApp</v-btn>
              </v-flex>              
            </v-layout>            
          </v-container>
          <small>* Este compartilhamento será váido por 7 dias</small>
        </v-card-text>         
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click.native="dialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <iframe id="vframe" frameborder="0" width="0" height="0"></iframe>
    </div>

    <impressao-dialog v-if="resultado.possuiImagem && resultado.empresa.impressao"  :resultado="resultado" :mostrar.sync="dialogImpressao" />

    <v-snackbar
      :timeout="timeoutAlerta"
      :color="tipoAlerta"
      v-model="snackbar">
      {{ textAlerta }}
      <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>

  </v-card>

</template>

<script>

import PdfDialog from '@/components/PdfDialog'
import ViewerDialog from '@/components/ViewerDialog'
import ImpressaoDialog from '@/components/ImpressaoDialog'

import axios from 'axios'
import moment from 'moment'
moment.locale('pt-BR')

export default {
  name: 'resultado-card',
  props: {
    resultado: {}
  },
  data () {
    return {
      items: [],
      errors: [],
      total: null,
      cabecalho: {},
      titulo: 'Resultados',
      dialogPdf: false,
      dialogViewer: false,
      dialogImpressao: false,
      linkViewer: null,
      linkPdf: null,
      share: {},
      dialog: false,
      email: null,
      emailRules: [
        v => !!v || 'E-mail obrigatório',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail inválido'
      ],
      valid: false,
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    }
  },
  components: {
    PdfDialog,
    ViewerDialog,
    ImpressaoDialog
  },
  computed: {
    linkWpp () {
      return `whatsapp://send?text=${this.textSocial}`
    },
    nomeFantasia () {
      let nome = this.resultado.empresa.nomeFantasia ? this.resultado.empresa.nomeFantasia : this.resultado.empresa.nome
      if (this.resultado.unidade.id) {
        nome = this.resultado.unidade.nomeFantasia ? this.resultado.unidade.nomeFantasia : this.resultado.unidade.nome
      }
      return nome
    },
    textSocial () {
      var br = '\r\n'
      // var mono = '```'
      var message = `*${this.resultado.empresa.nome}* `

      message += br + br + `O paciente *${this.resultado.nomePaciente}* compartilhou o resultado do exame *${this.resultado.tipoExame}* ( *${this.resultado.modalidade}* ) feito na empresa *${this.resultado.empresa.nome}* com você.`
      message += br + br + 'Para visualizar as imagens e o laudo digital acesse o através das informações abaixo:'

      message += br + br + `Usuário: *${this.share.username}*`
      message += br + `Senha: *${this.share.password}*`
      message += br + `Link do Resultado: ${this.share.link}`
      message += br + br + this.share.dataValidade

      return encodeURIComponent(message)
      // return encodeURIComponent(`Acesse o resultado do exame *${this.resultado.tipoExame}* *${this.resultado.modalidade}* do paciente *${this.resultado.nomePaciente}* feito na empresa *${this.resultado.empresa.nome}* através do link ${this.share.link} com o usuário: *${this.share.username}* e senha: *${this.share.password}*  (${this.share.dataValidade})`)
    }
    /* linkPdf () {
      return 'https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/mezzow-desen/arquivo_signed.pdf'
    },
    linkViewer () {
      var link = null
      var index = Object.keys(this.selected)[0]
      const res = this.selected[index]
      console.log(res)
      if (res) {
        link = 'http://localhost/mviewer/index.html'
      }
      return link
    }, */
  },
  methods: {
    moment (data) {
      return moment(data)
    },
    limparSelecao () {
      console.log(this.pagination)
    },
    openPdf (res) {
      // var index = Object.keys(this.selected)[0]
      // const medico = this.selected[index]
      this.dialogPdf = true
      var link = null
      this.resultado = res
      if (res) {
        let idConnect = res.idConnect ? res.idConnect : 'laudos'
        if (res.dataAssinatura) {
          link = `https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/${res.intervaloStorage}/${idConnect}/${res.id}_signed.pdf`
        } else {
          link = `https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/${res.intervaloStorage}/${idConnect}/${res.id}_add.pdf`
        }

        console.log('link??', link)
        this.linkPdf = link
      }
      // this.$router.push({name: 'MedicoEdit', params: { id: medico.id }})
    },
    detectmob () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    compartilharWhatsapp (link) {
      var self = this
      axios.post(`/compartilhar`, this.resultado)
      .then(function (response) {
        self.share = response.data.info
        self.resultado.share = response.data.info
        console.log(self.resultado)
        if (self.share) {
          // var iframe = document.getElementById('vframe')
          // iframe.src = self.linkWpp
          // https://api.whatsapp.com/send?
          // window.open(self.linkWpp, self.id)
          // var safariWindow = window.open()
          window.location.href = self.linkWpp
          self.dialog = false
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    compartilharEmail () {
      console.log('share')
      var self = this
      axios.post(`/email`, {resultado: this.resultado, email: this.email})
      .then(function (response) {
        self.share = response.data
        console.log(self.share)
        if (self.share) {
          self.tipoAlerta = 'success'
          self.textAlerta = 'E-mail enviado com sucesso para ' + self.share.email
          self.snackbar = true
          self.dialog = false
        }
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Ocorreu um erro ao compartilhar resultado.'
        self.snackbar = true
      })

      /* if (navigator.share) {
        navigator.share({
          title: 'Resulstado de Exame',
          text: `${res.empresa.nome}: ${res.tipoExame} - ${res.modalidade} do paciente ${res.nomePaciente}`,
          url: `https://resultados.mezzow.com/#/resultado/${res.id}`
        })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error))
      } */
    },
    buscarImage (res) {
      var link = `https://storage.googleapis.com/${res.intervaloStorage}/${res.idConnect}/capa.jpg`
      return link
    },
    openViewer (res) {
      this.buscarImage(res)
      console.log(res)
      if (res) {
        if (this.detectmob()) {
          link = `https://mviewer.mezzow.com/mindex.html?eid=${res.idConnect}&st=${res.intervaloStorage}&em=${res.email}`
          window.open(link, res.idConnect)
        } else {
          this.dialogViewer = true
          var link = null
          this.resultado = res
          link = `https://mviewer.mezzow.com/index.html?eid=${res.idConnect}&st=${res.intervaloStorage}&em=${res.email}`
          this.linkViewer = link
        }
      }
      // this.$router.push({name: 'MedicoEdit', params: { id: medico.id }})
    }
  },
  created () {
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// ResultadoCard.vue?68a595df